import {Injectable} from '@angular/core';

export interface FenceBlock {
  type: string;
  content: any;
  rawContent: string;
}

@Injectable({
  providedIn: 'root'
})
export class MessageParserService {

  parseMessage(message: string): (string | FenceBlock)[] {
    const regex = /:::([\w_]+)\s*([\s\S]*?):::/g;
    const parts: (string | FenceBlock)[] = [];
    let lastIndex = 0;
    let match;

    while ((match = regex.exec(message)) !== null) {
      // Add text before the fence block
      if (match.index > lastIndex) {
        parts.push(message.substring(lastIndex, match.index));
      }

      // Parse the fence block
      try {
        const type = match[1];
        const content = JSON.parse(match[2]);
        parts.push({
          type,
          content,
          rawContent: match[0]
        });
      } catch (error) {
        console.error('Error parsing fence block:', error);
        // If JSON parsing fails, add as plain text
        parts.push(match[0]);
      }

      lastIndex = regex.lastIndex;
    }

    // Add remaining text
    if (lastIndex < message.length) {
      parts.push(message.substring(lastIndex));
    }

    return parts;
  }
}
